import { queryOptions } from "@tanstack/react-query";
import { getLivePostStats, listPublishedPosts, listServices } from "@/lib/public.functions";

export const blogPostsQ = () =>
  queryOptions({
    queryKey: ["public", "posts", { limit: 50 }],
    queryFn: () => listPublishedPosts({ data: { limit: 50, offset: 0 } }),
  });
export const blogStatsQ = () =>
  queryOptions({ queryKey: ["public", "posts", "stats"], queryFn: () => getLivePostStats() });
export const blogServicesQ = () =>
  queryOptions({ queryKey: ["public", "services"], queryFn: () => listServices() });

export const PACKAGE_SLUG = "monthly-package-4";

export function consultPrices(services: any[] | null | undefined) {
  const list = services ?? [];
  const consult = list.find((s) => s.slug !== PACKAGE_SLUG) ?? null;
  const pkg = list.find((s) => s.slug === PACKAGE_SLUG) ?? null;
  return {
    duration: consult?.duration_min ?? null,
    price: consult ? Number(consult.price_usd) : null,
    packagePrice: pkg ? Number(pkg.price_usd) : null,
  };
}
